
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import facturacion from '@view/a-pedidos-ml/pc/facturacion/facturacion-unitario.vue';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import _ from 'lodash';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            facturacion
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorInterfaz;
        public get Publicacion() { return this.Controlador.Publicacion; }
        public get Estado() { return this.Controlador.Vista.Estado; }

        public Cargando: boolean = false;
        public Abrir: boolean = false;
        public get Ok(): boolean
        {
            return this.Publicacion.Estado.esActiva;
        }

        public async Ejecutar()
        {
            this.Cargando = true;
            let e = await this.Publicacion.Pausar();
            if ( !e )
            {
                Utiles.Notificaciones.Error( 'Error al modificar la publicación' );
            } else
            {
                this.Controlador.Recargar();
            }
            this.Cargando = false;

        }


    }
